export const TemplateSourceTypes = {
    file: 'File',
    relational: 'Relational'
};
